import { PAGE_NAV_TITLE as INDICES_PAGE_NAV_TITLE } from "components/indices/bindings";
import AppConfig from "util/AppConfig";
import ArchiveRetentionFields from "archive/index-set/ArchiveRetentionFields";
import useIndexSetSubmitConfirmation from "archive/index-set/useIndexSetSubmitConfirmation";
import DeleteFailedSnapshotMenuItem from "./DeleteFailedSnapshotMenuItem";
import DataTieringRoutes from "./Routes";
import TiersConfigurationFields from "./TiersConfigurationFields";
import TiersSummary from "./TiersSummary";
import WarmTierReadinessInfo from "./WarmTierReadinessInfo";
import WarmTierRepositoriesPage from "./warm-tier-repositories/WarmTierRepositoriesPage";
const isCloud = AppConfig.isCloud();
export default {
  dataTiering: {
    type: "hot_warm",
    TiersConfigurationFields,
    TiersSummary,
    WarmTierReadinessInfo,
    DeleteFailedSnapshotMenuItem,
    ArchiveRetentionFields,
    useIndexSetSubmitConfirmation
  },
  routes: isCloud ? [] : [
    {
      path: DataTieringRoutes.unqualified.WARM_TIER_REPOSITORIES,
      component: WarmTierRepositoriesPage,
      permissions: ["indexsets:read"]
    }
  ],
  pageNavigation: isCloud ? [] : [
    {
      description: INDICES_PAGE_NAV_TITLE,
      children: [
        {
          description: "Warm Tier Repositories",
          titleKey: "enterprise_navigation:indices.warm_tier_repositories",
          path: DataTieringRoutes.WARM_TIER_REPOSITORIES,
          permissions: ["indexsets:read"],
          position: {
            after: "Indices & Index Sets"
          }
        }
      ]
    }
  ]
};
